import styled from 'styled-components/macro'
import { getStatusColor } from './StatusIndicator.helpers'
import { STATUS_TYPES } from './StatusIndicator.constants'

export const StatusIndicatorBar = styled.div<{
  statusType: STATUS_TYPES
  status: number
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: .5rem;
  height: 100%;
  background-color: ${({ statusType, status }) =>
    getStatusColor(statusType, status)};
  }};
`

export const StatusIndicatorCircle = styled.div<{
  backgroundColor: string
  borderColor: string
}>`
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: 2px solid ${({ borderColor }) => borderColor};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
  color: #fff;
  font-weight: 700;
`
